import { createApp } from 'vue'
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

// Select the App you want to run on main, each individual are on /appName/App.vue
import SearchBar from './SearchBar.vue';

import dayjs from 'dayjs';
import dayjsLocales from '../../../services/dayjs-locales.service';
import localeData from 'dayjs/plugin/localeData';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isBetween from 'dayjs/plugin/isBetween';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import weekOfYear from 'dayjs/plugin/weekOfYear';

let locale = document.documentElement.lang;

async function loadLocale() {
  if (!dayjsLocales[locale]) {
    locale = 'default';
  }

  const localeData = await dayjsLocales[locale]().then(() => dayjs.locale(locale));
  dayjs.locale(localeData);
}


const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
const revueForm = document.getElementById('revue-form')
const app = createApp(SearchBar);

async function initApp() {
  await loadLocale();
  dayjs.extend(localeData);
  dayjs.extend(isoWeek);
  dayjs.extend(isSameOrBefore);
  dayjs.extend(customParseFormat);
  dayjs.extend(isBetween)
  dayjs.extend(weekOfYear)
  dayjs.localeData();

  app.config.globalProperties.$dayjs = dayjs;

  app.use(pinia)

  if (revueForm) {
    app.mount("#search-bar");
    // if the user is using an apple mobile device, we need to mount the search bar immediately
    // for some reason, those devices requires two presses to open the modal, and not one like other browsers
    // we now also mount immediately as this script is loaded in later
  }
}

initApp();
